import React, { useState } from 'react'
import { Form, Input, Button, Spin } from 'antd';
import { AuthWrapper } from '../../style';
import Heading from '../../../../../../components/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import { verifyPasswordReset } from '../../../../../../redux/authentication/actionCreator';
import "./Password.css";


function Password() {
    const [same, setSame] = useState(false);
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.auth.loading);
    const { kycToken, customerId } = useSelector(state => state.auth.dataForm);
    const submitPassword = ({ password }) => {
        let param = {
            password,
            kycToken,
            customerId
        }
        dispatch(verifyPasswordReset(param))
    }

    return (
        <AuthWrapper>
            <div className="auth-contents">
                <Form name="register" onFinish={submitPassword} layout="vertical">
                    <Heading as="h5">
                        Tetapkan kata laluan
                    </Heading>
                    <Form.Item
                        name="password"
                        label="Kata Laluan Baru"
                        rules={[
                            { required: true, message: 'Kata Laluan Baru' },
                            {
                                pattern: new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&#])([a-zA-Z0-9@$!%*?&#]{10,})$"),
                                message: 'Minimum:  10, 1 Huruf besar, 1 Huruf kecil, 1 Aksara, 1 digit'
                            },

                        ]}
                        hasFeedback
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item
                        name="confirm"
                        label="Kata Laluan Baru"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: 'Sahkan Kata Laluan Baru',
                            },
                            ({ getFieldValue }) => ({
                                validator(rule, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        setSame(true)
                                        return Promise.resolve();
                                    }
                                    return Promise.reject('Kata laluan tidak sepadan!');
                                },
                            }),
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item>
                        <Button className="btn-create" htmlType="submit" type="primary" size="large" disabled={isLoading || !same}>
                            {isLoading ? <Spin /> : 'TETAP KATA LALUAN'}
                        </Button>
                    </Form.Item>
                </Form>
            </div>

        </AuthWrapper>
    )
}

export default Password
